import React, { useEffect, useState } from 'react';

const SerialNoGenerate = ({ show, onClose, count = 1, handleSubmit, data = [], handleUpdate, index }) => {
    const [serialNumbers, setSerialNumbers] = useState([]);
    const [errors, setErrors] = useState([]);
    const [duplicateError, setDuplicateError] = useState('');

    useEffect(() => {
        if (show) {
            // Initialize with empty strings up to count
            const generated = Array.from({ length: count }, (_, i) => {
                return data && data[i] ? data[i] : `SN${String(i + 1).padStart(3, '0')}`;
            });
            const baseSerial = Date.now();
            const newSerials = [];

            for (let i = 1; i <= count; i++) {
                newSerials.push(data && data[i-1] ? data[i-1] : `${baseSerial}-${i}`)
            }

            setSerialNumbers(newSerials);
            setErrors(Array.from({ length: count }, () => false));
            setDuplicateError('');
        }
    }, [show, count, data]);

    const handleChange = (index, value) => {
        const updatedSerials = [...serialNumbers];
        updatedSerials[index] = value;
        setSerialNumbers(updatedSerials);

        // Clear errors when user types
        if (errors[index]) {
            const updatedErrors = [...errors];
            updatedErrors[index] = false;
            setErrors(updatedErrors);
        }

        // Clear duplicate error when user types
        if (duplicateError) {
            setDuplicateError('');
        }
    };

    const validateForm = () => {
        let isValid = true;

        // Check for empty fields
        const newErrors = serialNumbers.map(serial => {
            if (!serial.trim()) {
                isValid = false;
                return true;
            }
            return false;
        });
        setErrors(newErrors);

        // Check for duplicates
        const uniqueSerials = new Set();
        let hasDuplicates = false;
        let duplicateserial = ""
        serialNumbers.forEach(serial => {
            const trimmedSerial = serial.trim();
            if (trimmedSerial && uniqueSerials.has(trimmedSerial)) {
                hasDuplicates = true;
                duplicateserial = trimmedSerial
            }
            uniqueSerials.add(trimmedSerial);
        });

        if (hasDuplicates) {
            setDuplicateError("All serial numbers must be unique '" + duplicateserial + "' As Repeated");
            isValid = false;
        }

        return isValid;
    };

    const onSubmit = () => {
        if (validateForm()) {
            const submittedData = serialNumbers.filter(serial => serial.trim() !== "");
            if (data.length === 0 && handleSubmit) {
                handleSubmit(JSON.stringify(submittedData));
            } else {
                handleUpdate(index, JSON.stringify(submittedData), "serial_number");
                onClose();
            }
        }
    };

    return (
        <div
            className={`modal fade bg-light-transparent ${show ? "show" : ""}`}
            style={{ display: show ? "block" : "none" }}
            tabIndex="-1"
            role="dialog"
        >
            <div className="modal-dialog">
                <div className="modal-content p-3">
                    {/* Modal Header */}
                    <div className="modal-header border-0">
                        <h5 className="modal-title fw-bold text-dark font-18">Serial No Generate</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                    </div>

                    {/* Modal Body */}
                    <div className="modal-body">
                        {duplicateError && (
                            <div className="alert alert-danger mb-3">
                                {duplicateError}
                            </div>
                        )}
                        <div className="row">
                            {serialNumbers.map((serial, index) => (
                                <div className="col-12 mb-3" key={index}>
                                    <label className="form-label fw-semibold">
                                        Serial Number #{index + 1}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors[index] ? 'is-invalid' : ''}`}
                                        value={serial}
                                        onChange={(e) => handleChange(index, e.target.value)}
                                        required
                                    />
                                    {errors[index] && (
                                        <div className="invalid-feedback">
                                            Serial number is required
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="modal-footer border-0">
                        <button
                            onClick={onSubmit}
                            className="w-full mt-2 btn btn-success text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-blue-700 transition"
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SerialNoGenerate;